import { createContext, useContext } from 'react';
import { createStore, useStore as useZustandStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { PreloadedStoreInterface } from '@/providers/store-provider';

import { createFirebaseSlice, FirebaseSlice } from './slices/firebase-slice';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface StoreInterface extends FirebaseSlice {}

function getDefaultInitialState() {
  return {} as StoreInterface;
}

export type StoreType = ReturnType<typeof initializeStore>;

const storeContext = createContext<StoreType | null>(null);

export const Provider = storeContext.Provider;

export function useStore<T>(selector: (state: StoreInterface) => T) {
  const store = useContext(storeContext);

  if (!store) throw new Error('Store is missing the provider');

  return useZustandStore(store, useShallow(selector));
}

export function initializeStore(preloadedState: PreloadedStoreInterface) {
  const initialData = preloadedState.initialData;

  return createStore<StoreInterface>((...args) => ({
    ...getDefaultInitialState(),
    ...createFirebaseSlice(...args),
    ...initialData,
  }));
}
